// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__228Ke","inputWrap":"styles_inputWrap__34MzG","input":"styles_input__1QjkC"};